import { motion, useAnimationControls } from 'framer-motion';
import Image from 'next/image';
import { useEffect } from 'react';

const HeroAnimation = ({ isActive }: { isActive: boolean }) => {
  const handControls = useAnimationControls();

  // Ripple circles - exact CSS values & delays
  const circles = [
    {
      key: 'gradient',
      size: 126,
      style: {
        background:
          'linear-gradient(90deg, #E94E25 0%, #E94E25 49.52%, #E94E25 100%)',
        filter: 'blur(30px) saturate(1.1)',
      },
      delay: 1.1,
    },
    {
      key: 'circle-3',
      size: 280,
      style: { border: '1px solid #fff' },
      delay: 1.2,
    },
    {
      key: 'circle-2',
      size: 382,
      style: { border: '5px solid #fff' },
      delay: 1.35,
    },
    {
      key: 'circle-1',
      size: 484,
      style: { border: '13px solid #fff' },
      delay: 1.5,
    },
  ];

  useEffect(() => {
    if (isActive) {
      handControls.start('animate');
    } else {
      handControls.set('initial');
    }
  }, [isActive, handControls]);

  return (
    <div
      className="pointer-events-none absolute inset-0 hidden xl:block"
      style={{ zIndex: -1 }}
    >
      {circles.map((circle) => (
        <motion.div
          key={circle.key}
          className="absolute rounded-full"
          style={{
            width: circle.size,
            height: circle.size,
            top: '50%',
            left: '50%',
            ...circle.style,
          }}
          variants={{
            initial: { opacity: 0, x: '-50%', y: '-50%', scale: 0.9 },
            animate: {
              opacity: [0, 1, 1],
              x: '-50%',
              y: '-50%',
              scale: [0.9, 1.05, 1],
              transition: {
                duration: 0.6,
                delay: circle.delay,
                times: [0, 0.7, 1],
                ease: 'easeInOut',
              },
            },
          }}
          initial="initial"
          animate={handControls}
        />
      ))}
      <div
        className="absolute"
        style={{
          top: 'calc(50% - 30px)',
          left: '50%',
          transform: 'translateX(calc(-100% + 34px))',
        }}
      >
        <motion.div
          variants={{
            initial: { x: '-100%', y: '100%' },
            animate: {
              x: '0%',
              y: '0%',
              transition: { duration: 1.2, delay: 0.1, ease: 'easeOut' },
            },
          }}
          initial="initial"
          animate={handControls}
        >
          <Image
            src="/images/homePagev2/hv2.png"
            alt="Human Hand"
            width={628}
            height={529}
            priority
          />
        </motion.div>
      </div>
      <div
        className="absolute"
        style={{
          bottom: 'calc(50% - 14px)',
          right: '50%',
          transform: 'translateX(calc(100% - 66px))',
        }}
      >
        <motion.div
          variants={{
            initial: { x: '100%', y: '-100%' },
            animate: {
              x: '0%',
              y: '0%',
              transition: { duration: 1.2, delay: 0.1, ease: 'easeOut' },
            },
          }}
          initial="initial"
          animate={handControls}
        >
          <Image
            src="/images/homePagev2/robotv2.png"
            alt="Robot Hand"
            width={550}
            height={325}
            priority
          />
        </motion.div>
      </div>
    </div>
  );
};

export default HeroAnimation;
